import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: unknown): void {
    // Unwrap Angular-wrapped errors
    const unwrapped = this.unwrapError(error);

    // Skip HTTP errors — already handled by interceptors and component-level catchError
    if (unwrapped instanceof HttpErrorResponse) {
      return;
    }

    // Log with context
    const message = unwrapped instanceof Error ? unwrapped.message : String(unwrapped);
    const stack = unwrapped instanceof Error ? unwrapped.stack : undefined;

    console.error('[GlobalErrorHandler] Unhandled error:', message);
    if (stack) {
      console.error('[GlobalErrorHandler] Stack:', stack);
    }
  }

  private unwrapError(error: unknown): unknown {
    // Angular wraps some errors in an object with a `rejection` property (unhandled promise rejections)
    if (error && typeof error === 'object' && 'rejection' in error) {
      return (error as { rejection: unknown }).rejection;
    }
    return error;
  }
}
